import {
  SET_PS_CREDITS,
  SET_PS_TOTALFP,
  SET_PS_TOTALFP_L4,
  SET_PS_SELL_BY,
  SET_PS_PPG_YEAR,
  SET_PS_PPG_L4,
  SET_PS_GPP,
  SET_PS_H2H,
  SET_PS_PROJ_VAL,
  SET_PS_VAL_YEAR,
  SET_PS_VAL_L4,
  SET_PS_CEIL,
  SET_PS_FLOOR,
  SET_PS_CAP,
  SET_PS_VCAP,
  SET_PS_CAP_COUNT,
  SET_PS_VCAP_COUNT,
  SET_PS_DT_COUNT,
  SET_PS_M_COUNT,
  SET_PS_DTA,
  SET_PS_TFPR,
  SET_PS_TFPR_L4,
  SET_PS_AFPR,
  SET_PS_AFPR_L4,
  SET_PS_TFP,
  SET_PS_TFP_L4,
  SET_PS_AFP,
  SET_PS_AFP_L4 
} from "./PlayerStatInformation";

export const initial_ps_information = {
  ps_m_played: true,
  ps_cap_count: true,
  ps_vcap_count: true,
  ps_dta: true,
  ps_tfpr_count: false,
  ps_tfprL4_count: false,
  ps_afpr_count: false,
  ps_afprL4_count: false,
  ps_tfp: false,
  ps_tfpL4: false,
  ps_afp: false,
  ps_afpL4: false,
  ps_dt_count: true,
  ps_credits: false,
  ps_totalFP: true,
  ps_totalFPL4: true,
  ps_sellBy: false,
  ps_ppgYear: true,
  ps_ppgL4: true,
  ps_gpp: false,
  ps_h2h: false,
  ps_projVal: false,
  ps_valYear: false,
  ps_valL4: false,
  ps_ceil: true,
  ps_floor: true,
  ps_cap: false,
  ps_vcap: false,
  ps_proj_fp: true,
  player_responsibility: "P",
};

const playerStatInformationReducer = (
  state = initial_ps_information,
  action
) => {
  // console.log("===============  Player Reducer  ===============");
  // console.log("Action", action);
  // console.log("State", state);
  switch (action.type) {
    case SET_PS_CAP:
      return {
        ...state,
        ps_cap: action.ps_cap,
      };
    case SET_PS_VCAP:
      return {
        ...state,
        ps_vcap: action.ps_vcap,
      };
    case SET_PS_CREDITS:
      return {
        ...state,
        ps_credits: action.ps_credits,
      };
    case SET_PS_TOTALFP:
      return {
        ...state,
        ps_totalFP: action.ps_totalFP,
      };
    case SET_PS_M_COUNT:
      return {
        ...state,
        ps_m_played: action.ps_m_played,
      };
    case SET_PS_DT_COUNT:
      return {
        ...state,
        ps_dt_count: action.ps_dt_count,
      };
    case SET_PS_CAP_COUNT:
      return {
        ...state,
        ps_cap_count: action.ps_cap_count,
      };
    case SET_PS_VCAP_COUNT:
      return {
        ...state,
        ps_vcap_count: action.ps_vcap_count,
      };
    case SET_PS_TOTALFP_L4:
      return {
        ...state,
        ps_totalFPL4: action.ps_totalFPL4,
      };
    case SET_PS_SELL_BY:
      return {
        ...state,
        ps_sellBy: action.ps_sellBy,
      };
    case SET_PS_PPG_YEAR:
      return {
        ...state,
        ps_ppgYear: action.ps_ppgYear,
      };

    case SET_PS_PPG_L4:
      return {
        ...state,
        ps_ppgL4: action.ps_ppgL4,
      };
    case SET_PS_GPP:
      return {
        ...state,
        ps_gpp: action.ps_gpp,
      };
    case SET_PS_H2H:
      return {
        ...state,
        ps_h2h: action.ps_h2h,
      };
    case SET_PS_PROJ_VAL:
      return {
        ...state,
        ps_projVal: action.ps_projVal,
      };
    case SET_PS_VAL_YEAR:
      return {
        ...state,
        ps_valYear: action.ps_valYear,
      };
    case SET_PS_VAL_L4:
      return {
        ...state,
        ps_valL4: action.ps_valL4,
      };
    case SET_PS_CEIL:
      return {
        ...state,
        ps_ceil: action.ps_ceil,
      };
    case SET_PS_FLOOR:
      return {
        ...state,
        ps_floor: action.ps_floor,
      };
    case SET_PS_DTA:
      return {
        ...state,
        ps_dta: action.ps_dta,
      };
    case SET_PS_TFPR:
      return {
        ...state,
        ps_tfpr_count: action.ps_tfpr_count,
      };
    case SET_PS_TFPR_L4:
      return {
        ...state,
        ps_tfprL4_count: action.ps_tfprL4_count,
      };
    case SET_PS_AFPR:
      return {
        ...state,
        ps_afpr_count: action.ps_afpr_count,
      };
    case SET_PS_AFPR_L4:
      return {
        ...state,
        ps_afprL4_count: action.ps_afprL4_count,
      };
    case SET_PS_TFP:
      return {
        ...state,
        ps_tfp: action.ps_tfp,
      };
    case SET_PS_TFP_L4:
      return {
        ...state,
        ps_tfpL4: action.ps_tfpL4,
      };
    case SET_PS_AFP:
      return {
        ...state,
        ps_afp: action.ps_afp,
      };
    case SET_PS_AFP_L4:
      return {
        ...state,
        ps_afpL4: action.ps_afpL4,
      };

    default:
      // console.log("Player Stat Information Reducer Default");
      return state;
  }
};

export default playerStatInformationReducer;
